/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      thumbs: '[data-thumbs]',
      mediaItem: '[data-media-id]',
      slides: '.slide-item',
    };
    this.selectedMediaIndexORIGINAL = /* NOTE: This was used before we decided to filter images on first load by the selected variant */
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]',
        )?.dataset.index,
      ) || 0;
    this.selectedMediaIndex = 0;
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        thumbs: this.querySelector(this.selectors.thumbs),
      },
      instances: {
        slider: null,
        thumbs: null,
      },
      options: {
        slider: {
          initialSlide: this.selectedMediaIndex,
          spaceBetween: 20,
          watchOverflow: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        },
        thumbs: {
          initialSlide: this.selectedMediaIndex,
          slidesPerView: 'auto',
          spaceBetween: 20,
          centerInsufficientSlides: true,
          breakpoints: {
            990: {
              spaceBetween: 67,
            },
          },
        },
      },
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.settings.elements.slider || !this.settings.elements.thumbs)
      return;

    this.settings.instances.thumbs = new Swiper(
      this.settings.elements.thumbs,
      this.settings.options.thumbs,
    );
    this.settings.options.slider.thumbs = {
      swiper: this.settings.instances.thumbs,
    };

    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  setActiveMedia(id) { /* NOTE: This was used before we decided to filter the images on MainProductSelector.updateMedia() */
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem),
    ).find((media) => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
  }

  changeActiveSlide(id) {
    const matchingSlide = Array.from(
      this.settings.instances.slider.slides,
      (slide, index) => { return { el: slide, actualIndex: index } }
    ).find(slideObj => {
      return Number(slideObj.el.dataset.mediaId) === id
    });
    if (!matchingSlide) return;
    this.settings.instances.slider.slideTo(Number(matchingSlide.actualIndex));
  }

  filterMedia(variant) {
    const variantTitle = variant.title.toLowerCase();
    const slides = this.querySelectorAll(this.selectors.slides);
    slides.forEach(slide => {
      const _variant = slide.dataset.variant.toLowerCase();
      if (variantTitle === _variant) {
        slide.classList.remove("hide");
        slide.classList.add("swiper-slide");
      }
      else {
        slide.classList.add("hide");
        slide.classList.remove("swiper-slide");
      }
    });
    this.settings.instances.slider.update();
    this.settings.instances.thumbs.update();
    this.changeActiveSlide(variant.featured_media.id);
  }
}

customElements.define('product-media', ProductMedia);
